import React, { useContext } from 'react';
import classNames from 'classnames';
import brandPromiseSvgLogo from '../../../assets/logos/john-lewis-partners.svg';
import styles from './logobp.scss';
import EnvVarsFeaturesContext from '../../scaffold/EnvVarsFeaturesContext';

export const logoAssetsPath = assetsPath => asset =>
  assetsPath ? `${assetsPath}/images/${asset.split('/').pop()}` : asset;

const getLogoSrc = assetsPath => {
  const logoWithAssetsPath = logoAssetsPath(assetsPath);

  return logoWithAssetsPath(brandPromiseSvgLogo);
};

const LogoBP = ({ splashScreen }) => {
  const { envVars } = useContext(EnvVarsFeaturesContext);
  const logoSrc = getLogoSrc(envVars.assetsPath);

  return (
    <div
      className={classNames(styles.container, {
        [styles.container__expandedSearch]: splashScreen,
      })}
    >
      <a className={styles.link} href="/">
        <img
          src={logoSrc}
          alt="John Lewis & Partners Home"
          className={styles.logo}
        />
      </a>
    </div>
  );
};

export default LogoBP;
